module.exports = __webpack_public_path__ + "bd.svg?e5a2a6355e041abfe96c07b66a87b2f8";